import React, { createContext, useReducer } from 'react'

export const SET_DEVICES_DATA = 'SET_DEVICES_DATA'
export const UPDATE_CHANGE_DEVICES_DATA = 'UPDATE_CHANGE_DEVICES_DATA'
export const SET_SELECTED_DEVICES_DATA = 'SET_SELECTED_DEVICES_DATA'

export const SET_SHOW_HIDE_DEVICES_POPUP = 'SET_SHOW_HIDE_DEVICES_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_DEVICES_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CHANGE_DEVICES_DATA: {
      let tempData = [...data.data.data]
      tempData[payload.data.index] = payload.data
      return {
        ...data,
        data: { ...data.data, data: tempData },
        showDeviceFormPopup: false,
        selectedObject: {},
      }
    }
    case SET_SELECTED_DEVICES_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showDeviceFormPopup: true,
      }
    }
    case SET_SHOW_HIDE_DEVICES_POPUP: {
      if (payload.data) {
        return { ...data, showDeviceFormPopup: payload.data }
      } else {
        return {
          ...data,
          showDeviceFormPopup: payload.data,
          selectedObject: {},
        }
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: { data: [], pagination: {} },
  selectedObject: {},
  showDeviceFormPopup: false,
}

const DeviceStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <DeviceContext.Provider value={[state, dispatch]}>
      {children}
    </DeviceContext.Provider>
  )
}

export const DeviceContext = createContext(initialState)
export default DeviceStore
